import React, { useMemo } from 'react';
import {Menu} from 'antd';
import type {MenuProps} from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';

import ROUTES from 'constants/routes';
import {
  CommentOutlined,
  FileDoneOutlined, LayoutOutlined,
  SettingOutlined,
  UsergroupAddOutlined
} from "@ant-design/icons";
import { useAppSelector } from 'store';
import { tokenInfoSelector } from 'store/auth/auth.selectors';
import { ROLES } from 'constants/roles';

type MenuItem = Required<MenuProps>['items'][number];

const adminMenuItems: MenuItem[] = [
  {
    label: 'Администрирование',
    key: ROUTES.ADMINISTRATION,
    icon: <UsergroupAddOutlined />,
  },
  {
    label: 'Настройки',
    key: ROUTES.SETTINGS,
    icon: <SettingOutlined />
  },
]

const menuItems: MenuItem[] = [
  {
    label: 'Рассылки',
    key: ROUTES.DISTRIBUTION,
    icon: <CommentOutlined />,
  },
  {
    label: 'Рекомендации',
    key: ROUTES.RECOMMENDATIONS,
    icon: <FileDoneOutlined />,
  },
  {
    label: 'Информационные сообщения',
    key: ROUTES.INFO_MESSAGES,
    icon: <LayoutOutlined />,
  }
]

const SidebarMenu: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const tokenInfo = useAppSelector(tokenInfoSelector);

  const items = useMemo(() => {
    if (tokenInfo?.roles.includes(ROLES.ROLE_ADMIN)) {
      return [...adminMenuItems, ...menuItems];
    }
    return menuItems;
  }, [tokenInfo?.roles])

  const defaultSelectedKeys = useMemo(() => {
    const key = items.find((item) => item?.key === location.pathname)?.key
    return key ? [String(key)] : []
  }, [location.pathname, items])

  const handleClick = ({ key }: { key: string }) => {
    navigate(key)
  }
  return (
    <Menu
      onClick={handleClick}
      defaultSelectedKeys={defaultSelectedKeys}
      mode="inline"
      items={items}
    />
  );
}

export default SidebarMenu;
